import { IFormTemplateDTO } from '@/dtos';
import { get } from '@/services/apiWrapper';

export const getDefaultTermsFormTemplatedAPI = async (): Promise<IFormTemplateDTO> => {
  const user = get<IFormTemplateDTO>('/form/template/default/terms');
  return user;
};

export const getFormTemplateAPI = async (formTemplateId: string): Promise<IFormTemplateDTO> => {
  const user = get<IFormTemplateDTO>(`/form/template/${formTemplateId}`);
  return user;
};
